import React from "react";
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import classNames from "classnames";
import {useAppState, useRootStore, useUserState, useDsManager} from "@stores/AppStateContext";

import {isFreePlan} from "../../../../stores/client";
import {Button} from "../../../components/Button/Button";
import {RocketLaunch} from "../../../components/icons/RocketLaunchIcon";
import {DummyBox} from "../../../components/Dummy/DummyBox";

import {MODALS} from "../../../screens/modals/modal-names";

export interface UpgradePlanButtonProps {
    contentType: "iconWithFullText" | "icon" | "fullText" | "shortText",
    className?: string;
    fullWidth?: boolean
}

export const UpgradePlanButton = observer((
    {
        className,
        fullWidth,
        contentType
    }: UpgradePlanButtonProps) => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const userState = useUserState();
    const dsManager = useDsManager();
    // const subscription_plan = dsManager?.clientAR.row?.subscription_plan;
    const subscription_plan = 'free_trial'
    let buttonText;
    let icon;
    switch (contentType) {
        case "iconWithFullText": {
            buttonText = intl.get('header_menu.upgrade').d('Upgrade plan')
            icon = RocketLaunch
        }
            break
        case "fullText": {
            buttonText = intl.get('header_menu.upgrade').d('Upgrade plan')
        }
            break
        case "shortText": {
            buttonText = intl.get('common.upgrade').d('Upgrade')
        }
            break
        case "icon": {
            icon = RocketLaunch
        }
            break
    }
    return (
        <div className={classNames({
            [className!]: className && isFreePlan(subscription_plan),
        })}>
            {
                rootStore.view.workspace?.isReady && rootStore.isReady ? (
                    isFreePlan(subscription_plan) && userState!.isCurrentUserAdmin ? (
                            <Button
                                type="accent"
                                fullWidth={fullWidth}
                                style="solid"
                                onClick={() => {
                                    appState.setModal({name: MODALS.CHECKOUT, params: undefined})
                                }}
                                Icon={icon}
                                size='md'
                                text={buttonText}
                            />
                        )
                        : null
                ) : (
                    <DummyBox
                        width={'148px'}
                        className='HeaderRightPart_DummyBox'
                    />
                )
            }
        </div>
    )
})
